import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
    Box, Container, Heading, Flex, HStack, VStack, Stack, Text, Badge, Button, ButtonGroup, Select, Input, Textarea,
    InputGroup, InputLeftElement, InputRightElement, IconButton, SimpleGrid, Spinner, Tag, Drawer, DrawerOverlay, Grid, Icon, Tooltip, Divider, Image, Link, Avatar,
    DrawerContent, DrawerHeader, DrawerBody, DrawerCloseButton, Tabs, TabList, TabPanels,
    Tab, TabPanel, useToast, Wrap, WrapItem, Modal, ModalOverlay, ModalContent, ModalHeader,
    ModalBody, ModalFooter, ModalCloseButton, useDisclosure, Radio, RadioGroup, Alert, AlertIcon,
} from '@chakra-ui/react';
import {
    FaSearch, FaSyncAlt, FaClock, FaExclamationTriangle, FaUserClock, FaShieldAlt, FaPaperPlane,
    FaList, FaColumns, FaChartBar, FaUser, FaStore, FaUserTie, FaBoxOpen, FaMapMarkerAlt,
    FaCheckCircle, FaExclamationCircle, FaTimes, FaPaperclip, FaExternalLinkAlt, FaFileInvoiceDollar, FaTicketAlt,
    FaPlus, FaEdit, FaTrash, FaMoneyBillWave, FaReceipt,
} from 'react-icons/fa';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import ProdutoImagem from '../components/ProdutoImagem';
import ScrollToTop from '../components/ScrollToTop';
import ReclamacoesMetricas from '../components/ReclamacoesMetricas';
import { baseUrlApi } from '../config';
import { formatBRL, formatDateTime, formatDate } from '../utils/formatters';
import {
    getReclamacoes, getReclamacaoDetalhe, refreshReclamacao, responderMensagemReclamacao,
    abrirDisputaReclamacao, reembolsoTotalReclamacao, ofertasParciaisReclamacao,
    reembolsoParcialReclamacao, oferecerDevolucaoReclamacao, getAnexoReclamacao, uploadAnexoReclamacao, criarObsVenda,
    excluirReclamacaoManual, atualizarReclamacaoManual, baixarComprovanteReembolsoMp,
} from '../services/api';
import NovaReclamacaoManualModal from '../components/NovaReclamacaoManualModal';
import EditarReclamacaoManualModal from '../components/EditarReclamacaoManualModal';
import ReembolsoMercadoPagoModal from '../components/ReembolsoMercadoPagoModal';
import { useConfirm } from '../components/ConfirmDialog';

dayjs.locale('pt-br');

const URGENCIA = {
    vencido: { label: 'Vencido', color: 'red' },
    critico: { label: 'Crítico', color: 'orange' },
    atencao: { label: 'Atenção', color: 'yellow' },
    no_prazo: { label: 'No prazo', color: 'green' },
    aguardando_terceiro: { label: 'Aguardando', color: 'blue' },
    sem_prazo: { label: 'Sem prazo', color: 'gray' },
};

const RESPONSAVEL = {
    seller: { label: 'Sua vez de responder', curto: 'Você', color: 'orange', icon: FaUserTie },
    respondent: { label: 'Sua vez de responder', curto: 'Você', color: 'orange', icon: FaUserTie },
    buyer: { label: 'Aguardando o comprador', curto: 'Comprador', color: 'blue', icon: FaUser },
    complainant: { label: 'Aguardando o comprador', curto: 'Comprador', color: 'blue', icon: FaUser },
    mediator: { label: 'Com o Mercado Livre', curto: 'Mercado Livre', color: 'purple', icon: FaStore },
};

const respKey = (r) => ((r === 'seller' || r === 'respondent') ? 'seller' : r === 'mediator' ? 'mediator' : 'buyer');

const FOTOS_USUARIO = { 3: '/gabriel_logo.webp', 5: '/tilio_logo.webp', 6: '/riccioppo_logo.webp', 8: '/gabriel_valiente_logo.webp', 9: '/emerson_vendedor_logo.webp', 10: '/analuiza_logo.webp' };
const imgUsuario = (id) => FOTOS_USUARIO[id] || undefined;

const PAPEL = { complainant: 'Comprador', respondent: 'Você (vendedor)', mediator: 'Mercado Livre', seller: 'Você (vendedor)', buyer: 'Comprador' };
const papelLabel = (k) => PAPEL[k] || k || 'Não informado';

const RESOLUCAO_REASON = {
    warehouse_decision: 'Decisão do Mercado Livre',
    refund: 'Reembolso ao comprador',
    refunded: 'Reembolso ao comprador',
    payment_refunded: 'Reembolso ao comprador',
    payment_in_process: 'Reembolso em processamento',
    partial_refunded: 'Reembolso parcial',
    partial_refund: 'Reembolso parcial',
    product_returned: 'Produto devolvido',
    return_received: 'Devolução recebida',
    return_expired: 'Devolução expirada',
    seller_solved: 'Resolvido pelo vendedor',
    buyer_solved: 'Resolvido pelo comprador',
    buyer_cancel: 'Cancelado pelo comprador',
    seller_cancel: 'Cancelado pelo vendedor',
    dispute_solved: 'Mediação resolvida',
    charged_back: 'Estorno (chargeback)',
    no_admit: 'Reclamação não procedente',
};
const labelResolucao = (k) => RESOLUCAO_REASON[k] || (k ? k.replace(/_/g, ' ') : 'Não informado');

const ACAO_LABEL = {
    open_claim: 'Reclamação aberta',
    allow_return: 'Devolução autorizada',
    generate_return: 'Etiqueta de devolução gerada',
    generate_return_async: 'Devolução gerada',
    generate_return_label: 'Etiqueta de devolução gerada',
    return_review: 'Devolução em revisão',
    return_in_transit: 'Devolução a caminho',
    return_delivered: 'Devolução entregue',
    refund: 'Reembolso efetuado',
    refund_async: 'Reembolso processado',
    allow_partial_refund: 'Reembolso parcial oferecido',
    partial_refund: 'Reembolso parcial efetuado',
    open_dispute: 'Mediação aberta',
    dispute: 'Mediação',
    escalate_to_mediation: 'Escalado para mediação',
    ask_seller_solution: 'Solicitada solução ao vendedor',
    change_claim_reason: 'Motivo da reclamação alterado',
    recontact: 'Recontato',
    coverage: 'Cobertura aplicada',
    review_evidences: 'Evidências analisadas',
    send_message_to_complainant: 'Mensagem ao comprador',
    send_message_to_mediator: 'Mensagem ao Mercado Livre',
    send_message: 'Mensagem enviada',
    close_claim: 'Reclamação encerrada',
    claim_closed: 'Reclamação encerrada',
    close_with_resolution: 'Encerrado com resolução',
};
const labelAcao = (k) => ACAO_LABEL[k] || (k ? k.replace(/_async$/, '').replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase()) : 'Ação');

function htmlParaTexto(html) {
    if (!html) return '';
    if (!/[<&]/.test(html)) return html;
    let s = html
        .replace(/<\s*br\s*\/?>/gi, '\n')
        .replace(/<\/\s*p\s*>/gi, '\n')
        .replace(/<\/\s*div\s*>/gi, '\n')
        .replace(/<\s*li[^>]*>/gi, '\n• ')
        .replace(/<\/\s*li\s*>/gi, '')
        .replace(/<[^>]+>/g, '');
    s = s
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#0?39;/gi, "'")
        .replace(/&apos;/gi, "'");
    return s.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
}
const contaLabel = (c) => 'Conta ' + (['2', '3'].includes(String(c)) ? String(c) : '1');

// Canais de origem da reclamação: 'ml' cobre o Mercado Livre (inclusive os
// registros antigos, sem origem gravada); os demais são reclamações manuais.
const ORIGENS = [
    { value: '', label: 'Todas origens' },
    { value: 'ml_1', label: 'ML 1' },
    { value: 'ml_2', label: 'ML 2' },
    { value: 'ml_3', label: 'ML 3' },
    { value: 'ecommerce', label: 'E-commerce' },
    { value: 'taga', label: 'TAGA (Manual)' },
];
const ORIGEM_MAP = {
    '': { origem: '', conta: '' },
    ml_1: { origem: 'ml', conta: '1' },
    ml_2: { origem: 'ml', conta: '2' },
    ml_3: { origem: 'ml', conta: '3' },
    ecommerce: { origem: 'ecommerce', conta: '' },
    taga: { origem: 'taga', conta: '' },
};
const origemSelecionada = (f) => {
    if (f.origem === 'ml') return ['1', '2', '3'].includes(f.conta) ? `ml_${f.conta}` : '';
    if (f.origem === 'ecommerce') return 'ecommerce';
    if (f.origem === 'taga') return 'taga';
    return '';
};
const temAcao = (acoes, nome) => (acoes || []).some((a) => (a.action || a) === nome);

const copiar = async (valor, toast, label) => {
    if (!valor) return;
    try {
        await navigator.clipboard.writeText(String(valor));
        toast({ title: `${label} copiado`, description: String(valor), status: 'success', duration: 1600, isClosable: true, position: 'top-right' });
    } catch (e) {
        toast({ title: 'Falha ao copiar', status: 'error', duration: 1500, position: 'top-right' });
    }
};

function tempoRestante(dueDate) {
    const now = dayjs();
    const due = dayjs(dueDate);
    if (due.isBefore(now)) return 'vencido';
    const diasCal = due.startOf('day').diff(now.startOf('day'), 'day');
    if (diasCal === 0) {
        const h = due.diff(now, 'hour');
        return h <= 0 ? 'hoje' : `em ${h}h`;
    }
    if (diasCal === 1) return 'amanhã';
    return `em ${diasCal} dias`;
}

function PrazoBadge({ urgency, dueDate }) {
    const vencidoReal = dueDate && dayjs(dueDate).isBefore(dayjs());
    const effUrgency = (vencidoReal && ['critico', 'atencao', 'no_prazo'].includes(urgency)) ? 'vencido' : urgency;
    const u = URGENCIA[effUrgency] || URGENCIA.sem_prazo;
    let texto = u.label;
    if (dueDate && ['vencido', 'critico', 'atencao', 'no_prazo'].includes(effUrgency)) {
        texto = effUrgency === 'vencido' ? 'Vencido' : `Vence ${tempoRestante(dueDate)}`;
    }
    return (
        <Tooltip label={dueDate ? `Prazo para responder: ${formatDateTime(dueDate)}` : u.label} hasArrow>
            <Badge colorScheme={u.color} variant="solid" px={2} py={1} borderRadius="md" fontSize="11px" display="inline-flex" alignItems="center" gap="4px">
                <Icon as={FaClock} boxSize="9px" /> {texto}
            </Badge>
        </Tooltip>
    );
}

function ResponsavelBadge({ resp, size = 'sm' }) {
    const r = RESPONSAVEL[resp] || { curto: 'Indefinido', color: 'gray', icon: FaUserClock };
    return (
        <Tag size={size} colorScheme={r.color} variant="subtle" borderRadius="full">
            <Icon as={r.icon} mr={1} boxSize={3} /> {r.curto}
        </Tag>
    );
}

function AbrirLink({ label, href }) {
    if (!href) return null;
    return (
        <Tooltip label={label} openDelay={400} hasArrow>
            <Flex as="button" type="button" display="inline-flex"
                onClick={(e) => { e.stopPropagation(); window.open(href, '_blank', 'noopener'); }}
                align="center" justify="center" boxSize="18px" borderRadius="md" flexShrink={0}
                color="gray.400" _hover={{ bg: 'gray.200', color: 'orange.500' }} transition="all 0.12s">
                <FaExternalLinkAlt size={9} />
            </Flex>
        </Tooltip>
    );
}

function InfoRow({ label, value }) {
    return (
        <Box>
            <Text fontSize="10px" color="gray.500" fontWeight="semibold" textTransform="uppercase">{label}</Text>
            <Text fontSize="sm" color="gray.800" fontWeight="medium">{value || 'Não informado'}</Text>
        </Box>
    );
}

function statusVisual(rec) {
    if (rec.status === 'closed') return { key: 'closed', label: 'Finalizada', color: 'green', icon: FaCheckCircle };
    const r = RESPONSAVEL[rec.action_responsible] || RESPONSAVEL.buyer;
    return { key: respKey(rec.action_responsible), label: r.label, color: r.color, icon: r.icon };
}

function ContaTag({ conta, origem }) {
    if (origem && origem !== 'ml') {
        const o = String(origem).toUpperCase();
        return (
            <Tooltip label={`Reclamação manual · ${o}`} hasArrow>
                <Badge colorScheme="purple" variant="solid" borderRadius="md" px={1.5} fontSize="11px">Manual · {o}</Badge>
            </Tooltip>
        );
    }
    // Qualquer outra conta continua como ML 1 (como era antes da conta 3).
    const n = ['2', '3'].includes(String(conta)) ? String(conta) : '1';
    const cor = { 1: 'yellow', 2: 'blue', 3: 'green' }[n];
    return (
        <Tooltip label={`Conta Mercado Livre ${n}`} hasArrow>
            <Badge colorScheme={cor} variant="solid" borderRadius="md" px={1.5} fontSize="11px">ML {n}</Badge>
        </Tooltip>
    );
}

function IdChip({ valor, label }) {
    const toast = useToast();
    if (!valor) return null;
    const full = String(valor);
    const display = full.length > 16 ? '…' + full.slice(-14) : full;
    return (
        <Tooltip label={`${label}: ${full} · clique para copiar`} hasArrow>
            <Text as="span" fontSize="10px" fontFamily="mono" color="gray.600" cursor="pointer" _hover={{ color: 'orange.600' }}
                onClick={(e) => { e.stopPropagation(); copiar(full, toast, label); }}>{display}</Text>
        </Tooltip>
    );
}

function RefVenda({ resumo, rec }) {
    const ids = resumo?.ids || {};
    const lista = [
        { v: ids.id_venda || rec.id_venda, l: 'ID TAGA' },
        { v: ids.id_origem || rec.id_order_ml, l: 'ID Origem' },
        { v: ids.pack_id_ml, l: 'Pack ID' },
    ].filter((x) => x.v);
    if (lista.length === 0) return null;
    return (
        <HStack align="center" spacing={2} wrap="wrap">
            <Text fontSize="10px" color="gray.500" fontWeight="semibold" flexShrink={0}>Ref. Venda:</Text>
            <HStack spacing={2} wrap="wrap" rowGap={1} divider={<Text color="gray.300" fontSize="10px">|</Text>}>
                {lista.map((x, i) => <IdChip key={i} valor={x.v} label={x.l} />)}
            </HStack>
        </HStack>
    );
}

function RefItem({ produto }) {
    if (!produto) return null;
    const lista = [
        { v: produto.sku, l: 'SKU' },
        { v: produto.codigo_global, l: 'Cód. Global' },
        { v: produto.codigo_fornecedor, l: 'Cód. Fornecedor' },
    ].filter((x) => x.v);
    if (lista.length === 0) return null;
    return (
        <HStack align="center" spacing={2} wrap="wrap">
            <Text fontSize="10px" color="gray.500" fontWeight="semibold" flexShrink={0}>Ref. Item:</Text>
            <HStack spacing={2} wrap="wrap" rowGap={1} divider={<Text color="gray.300" fontSize="10px">|</Text>}>
                {lista.map((x, i) => <IdChip key={i} valor={x.v} label={x.l} />)}
            </HStack>
        </HStack>
    );
}

function DataAbertura({ rec }) {
    if (!rec.date_created_ml) return null;
    return (
        <Tooltip label={`Aberta no Mercado Livre em ${formatDateTime(rec.date_created_ml)}`} hasArrow>
            <HStack spacing={1} color="gray.500">
                <Icon as={FaClock} boxSize="9px" />
                <Text fontSize="10px">Aberta {formatDate(rec.date_created_ml)}</Text>
            </HStack>
        </Tooltip>
    );
}

function ProdutoMini({ resumo, size = '52px' }) {
    const prod = resumo?.produto;
    return (
        <Box w={size} h={size} flexShrink={0} borderRadius="md" overflow="hidden" bg="gray.50" borderWidth="1px" borderColor="gray.200">
            {prod ? (
                <ProdutoImagem produto={prod} origem={null} width={size} height={size} />
            ) : (
                <Flex w="full" h="full" align="center" justify="center"><Icon as={FaBoxOpen} color="gray.300" /></Flex>
            )}
        </Box>
    );
}

function StatCard({ label, value, color, icon, active, onClick }) {
    return (
        <Box as="button" onClick={onClick} textAlign="left" bg={active ? `${color}.500` : 'white'}
            borderWidth="1px" borderColor={active ? `${color}.500` : 'gray.200'} borderRadius="xl" p={4}
            transition="all .15s" boxShadow={active ? 'md' : 'sm'} _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}>
            <HStack justify="space-between" mb={1}>
                <Text fontSize="11px" color={active ? 'whiteAlpha.900' : 'gray.500'} fontWeight="bold" textTransform="uppercase">{label}</Text>
                <Icon as={icon} color={active ? 'white' : `${color}.400`} boxSize={4} />
            </HStack>
            <Text fontSize="3xl" fontWeight="extrabold" color={active ? 'white' : `${color}.600`} lineHeight="1">{value ?? 0}</Text>
        </Box>
    );
}

export default function Reclamacoes() {
    const toast = useToast();
    const [loading, setLoading] = useState(true);
    const [itens, setItens] = useState([]);
    const [stats, setStats] = useState({});
    const [view, setView] = useState('kanban');
    const [filtros, setFiltros] = useState({ conta: '', origem: '', status: 'opened', urgency_level: '', responsavel: '', busca: '', ordenacao: '' });
    const [selecionada, setSelecionada] = useState(null);
    const [detalhe, setDetalhe] = useState(null);
    const [carregandoDetalhe, setCarregandoDetalhe] = useState(false);
    const [atualizando, setAtualizando] = useState(false);
    const [novaManualOpen, setNovaManualOpen] = useState(false);
    const [editarManualOpen, setEditarManualOpen] = useState(false);
    const [excluindo, setExcluindo] = useState(false);
    const [reembolsoMpOpen, setReembolsoMpOpen] = useState(false);
    const [baixandoComprovante, setBaixandoComprovante] = useState(false);
    const { confirm, ConfirmPortal } = useConfirm();

    const carregar = useCallback(async () => {
        setLoading(true);
        const params = { per_page: 200 };
        const efetivos = { ...filtros };
        if (view === 'kanban' && efetivos.status === 'opened') efetivos.status = '';
        Object.entries(efetivos).forEach(([k, v]) => { if (v) params[k] = v; });
        const data = await getReclamacoes(params);
        if (data) { setItens(data.itens?.data || []); setStats(data.stats || {}); }
        setLoading(false);
    }, [filtros, view]);

    useEffect(() => { carregar(); }, [carregar]);

    const carregarDetalhe = async (id) => {
        setCarregandoDetalhe(true);
        const data = await getReclamacaoDetalhe(id);
        setDetalhe(data);
        setCarregandoDetalhe(false);
    };
    const abrirDetalhe = (rec) => { setSelecionada(rec); setDetalhe(null); carregarDetalhe(rec.id); };

    const atualizarDoML = async () => {
        if (!selecionada) return;
        setAtualizando(true);
        await refreshReclamacao(selecionada.id);
        await carregarDetalhe(selecionada.id);
        setAtualizando(false);
        toast({ title: 'Atualizado com o Mercado Livre', status: 'success', duration: 2000, position: 'top-right' });
        carregar();
    };

    const excluirManual = async () => {
        if (!selecionada) return;
        const ok = await confirm({
            title: 'Excluir reclamação manual?',
            body: 'Esta ação é permanente e removerá a reclamação do sistema.',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            confirmColor: 'red',
        });
        if (!ok) return;
        setExcluindo(true);
        const resp = await excluirReclamacaoManual(selecionada.id);
        setExcluindo(false);
        if (resp?.success) {
            toast({ title: 'Reclamação excluída', status: 'success', duration: 2500, position: 'top-right' });
            setSelecionada(null);
            carregar();
        } else {
            toast({ title: 'Falha ao excluir', description: resp?.error || 'Erro', status: 'error', duration: 5000 });
        }
    };

    const ehManual = selecionada?.origem && selecionada.origem !== 'ml';
    // Estorno pelo MP só existe em pedido do site (é lá que fica o pagamento).
    const ehEcommerce = selecionada?.origem === 'ecommerce';
    const reembolsoMp = detalhe?.reclamacao?.dados_adicionais?.reembolso_mp;

    const baixarComprovanteMp = async () => {
        setBaixandoComprovante(true);
        const ok = await baixarComprovanteReembolsoMp(
            selecionada.id,
            `comprovante-estorno-${detalhe?.venda?.id_origem || selecionada.id}.pdf`,
            'reclamacoes',
        );
        if (!ok) toast({ title: 'Erro ao baixar o comprovante de estorno.', status: 'error', duration: 6000 });
        setBaixandoComprovante(false);
    };

    const setFiltro = (k, v) => setFiltros((f) => ({ ...f, [k]: f[k] === v ? '' : v }));

    return (
        <Box bg="gray.50" minH="100vh">
            <ScrollToTop />
            <Container maxW="1280px" py={6}>
                <Flex justify="space-between" align="center" mb={5} wrap="wrap" gap={3}>
                    <Heading size="lg" color="#F68633" fontWeight="extrabold">Pós-venda · Reclamações e Mediações</Heading>
                    <HStack spacing={2}>
                        {view !== 'metricas' && (
                            <Button leftIcon={<FaPlus />} size="sm" onClick={() => setNovaManualOpen(true)} colorScheme="orange">Nova reclamação manual</Button>
                        )}
                        <Button leftIcon={<FaSyncAlt />} size="sm" onClick={carregar} colorScheme="orange" variant="outline">Atualizar</Button>
                    </HStack>
                </Flex>

                <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={3} mb={5}>
                    <StatCard label="Abertas" value={stats.abertas} color="blue" icon={FaClock} active={!filtros.urgency_level && !filtros.responsavel} onClick={() => setFiltros((f) => ({ ...f, urgency_level: '', responsavel: '' }))} />
                    <StatCard label="Sua vez" value={stats.minha_vez} color="orange" icon={FaUserTie} active={filtros.responsavel === 'seller'} onClick={() => setFiltro('responsavel', 'seller')} />
                    <StatCard label="Vencidas" value={stats.vencidas} color="red" icon={FaExclamationTriangle} active={filtros.urgency_level === 'vencido'} onClick={() => setFiltro('urgency_level', 'vencido')} />
                    <StatCard label="Críticas" value={stats.criticas} color="yellow" icon={FaClock} active={filtros.urgency_level === 'critico'} onClick={() => setFiltro('urgency_level', 'critico')} />
                    <StatCard label="Aguardando" value={stats.aguardando_terceiro} color="blue" icon={FaUserClock} active={filtros.urgency_level === 'aguardando_terceiro'} onClick={() => setFiltro('urgency_level', 'aguardando_terceiro')} />
                    <StatCard label="Afeta reputação" value={stats.afeta_reputacao} color="red" icon={FaShieldAlt} active={filtros.afeta_reputacao === 'affected'} onClick={() => setFiltro('afeta_reputacao', 'affected')} />
                </SimpleGrid>

                <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={3}>
                    <Wrap spacing={3} align="center" flex="1">
                        <WrapItem><InputGroup size="sm" w="230px"><InputLeftElement pointerEvents="none"><FaSearch color="gray" /></InputLeftElement><Input bg="white" placeholder="Buscar nº, produto, motivo..." value={filtros.busca} onChange={(e) => setFiltros((f) => ({ ...f, busca: e.target.value }))} /></InputGroup></WrapItem>
                        <WrapItem><Select size="sm" w="160px" bg="white" title="Origem da reclamação" value={origemSelecionada(filtros)} onChange={(e) => { const m = ORIGEM_MAP[e.target.value] || ORIGEM_MAP['']; setFiltros((f) => ({ ...f, origem: m.origem, conta: m.conta })); }}>{ORIGENS.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}</Select></WrapItem>
                        <WrapItem><Select size="sm" w="140px" bg="white" value={filtros.status} onChange={(e) => setFiltros((f) => ({ ...f, status: e.target.value }))}><option value="opened">Abertas</option><option value="closed">Encerradas</option><option value="">Todas</option></Select></WrapItem>
                        <WrapItem><Select size="sm" w="180px" bg="white" value={filtros.ordenacao} onChange={(e) => setFiltros((f) => ({ ...f, ordenacao: e.target.value }))}><option value="">Mais urgentes</option><option value="prazo">Prazo mais próximo</option><option value="recentes">Mais recentes</option><option value="antigas">Mais antigas</option><option value="atualizacao">Última atualização</option></Select></WrapItem>
                    </Wrap>
                    <ButtonGroup size="sm" isAttached variant="outline">
                        <Button leftIcon={<FaColumns />} colorScheme={view === 'kanban' ? 'orange' : 'gray'} variant={view === 'kanban' ? 'solid' : 'outline'} onClick={() => setView('kanban')}>Kanban</Button>
                        <Button leftIcon={<FaList />} colorScheme={view === 'list' ? 'orange' : 'gray'} variant={view === 'list' ? 'solid' : 'outline'} onClick={() => setView('list')}>Lista</Button>
                        <Button leftIcon={<FaChartBar />} colorScheme={view === 'metricas' ? 'orange' : 'gray'} variant={view === 'metricas' ? 'solid' : 'outline'} onClick={() => setView('metricas')}>Métricas</Button>
                    </ButtonGroup>
                </Flex>

                <Wrap spacing={2} mb={4} align="center">
                    {['seller', 'buyer', 'mediator'].map((r) => (
                        <WrapItem key={r}>
                            <Button size="xs" borderRadius="full" variant={filtros.responsavel === r ? 'solid' : 'outline'}
                                colorScheme={RESPONSAVEL[r].color} leftIcon={<Icon as={RESPONSAVEL[r].icon} />}
                                onClick={() => setFiltro('responsavel', r)}>{RESPONSAVEL[r].label}</Button>
                        </WrapItem>
                    ))}
                    {(filtros.conta || filtros.origem || filtros.responsavel || filtros.urgency_level || filtros.afeta_reputacao || filtros.busca || filtros.ordenacao || filtros.status !== 'opened') && (
                        <WrapItem>
                            <Button size="xs" borderRadius="full" variant="ghost" colorScheme="gray" leftIcon={<FaTimes />}
                                onClick={() => setFiltros({ conta: '', origem: '', status: 'opened', urgency_level: '', responsavel: '', afeta_reputacao: '', busca: '', ordenacao: '' })}>
                                Limpar filtros
                            </Button>
                        </WrapItem>
                    )}
                </Wrap>

                {loading ? (
                    <Flex justify="center" py={20}><Spinner size="lg" color="orange.400" /></Flex>
                ) : view === 'metricas' ? (
                    <ReclamacoesMetricas />
                ) : view === 'kanban' ? (
                    <KanbanView itens={itens} onAbrir={abrirDetalhe} />
                ) : itens.length === 0 ? (
                    <Box textAlign="center" py={16} color="gray.500" bg="white" borderRadius="lg"><Text fontSize="lg">Nenhuma reclamação encontrada.</Text></Box>
                ) : (
                    <VStack align="stretch" spacing={3}>
                        {itens.map((rec) => <CardReclamacao key={rec.id} rec={rec} onAbrir={abrirDetalhe} />)}
                    </VStack>
                )}
            </Container>

            <Drawer isOpen={!!selecionada} onClose={() => setSelecionada(null)} size={{ base: 'full', md: 'xl' }}>
                <DrawerOverlay />
                <DrawerContent sx={{ height: '100dvh' }}>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px" bg="gray.50" flexShrink={0} py={{ base: 3, md: 4 }} px={{ base: 3, md: 6 }}>
                        <HStack justify="space-between" pr={8} wrap="wrap" gap={2}>
                            <VStack align="start" spacing={0}>
                                <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="bold">
                                    {ehManual ? `Reclamação manual #${selecionada?.id}` : `Reclamação nº ${selecionada?.id_ml}`}
                                </Text>
                                <HStack>
                                    {selecionada && <ResponsavelBadge resp={selecionada.action_responsible} />}
                                    {ehManual && <ContaTag origem={selecionada.origem} />}
                                </HStack>
                            </VStack>
                            {ehManual ? (
                                <HStack spacing={2}>
                                    {ehEcommerce && detalhe?.reclamacao && (
                                        reembolsoMp ? (
                                            <Tooltip label={`Estorno de ${formatBRL(reembolsoMp.valor)} feito em ${reembolsoMp.data} por ${reembolsoMp.user_name}. Baixa o comprovante em PDF para enviar ao cliente.`} hasArrow>
                                                <Button size="xs" leftIcon={<FaReceipt />} isLoading={baixandoComprovante} onClick={baixarComprovanteMp} variant="outline" colorScheme="green">Comprovante do estorno</Button>
                                            </Tooltip>
                                        ) : (
                                            <Button size="xs" leftIcon={<FaMoneyBillWave />} onClick={() => setReembolsoMpOpen(true)} variant="outline" colorScheme="green">Devolver dinheiro (MP)</Button>
                                        )
                                    )}
                                    <Button size="xs" leftIcon={<FaEdit />} onClick={() => setEditarManualOpen(true)} variant="outline" colorScheme="blue">Editar</Button>
                                    <Button size="xs" leftIcon={<FaTrash />} isLoading={excluindo} onClick={excluirManual} variant="outline" colorScheme="red">Excluir</Button>
                                </HStack>
                            ) : (
                                <Button size="xs" leftIcon={<FaSyncAlt />} isLoading={atualizando} onClick={atualizarDoML} variant="outline" colorScheme="orange">Atualizar do ML</Button>
                            )}
                        </HStack>
                    </DrawerHeader>
                    <DrawerBody bg="gray.50" px={{ base: 3, md: 3 }} py={{ base: 3, md: 3 }} pb={{ base: 10, md: 3 }} flex="1" minH={0} display={{ base: 'block', md: 'flex' }} flexDirection="column" overflow={{ base: 'auto', md: 'hidden' }} sx={{ WebkitOverflowScrolling: 'touch' }}>
                        {carregandoDetalhe || !detalhe ? (
                            <Flex flex="1" justify="center" align="center"><Spinner color="orange.400" /></Flex>
                        ) : (
                            <DetalheReclamacao detalhe={detalhe} onAtualizar={() => { carregarDetalhe(selecionada.id); carregar(); }} />
                        )}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            <NovaReclamacaoManualModal
                isOpen={novaManualOpen}
                onClose={() => setNovaManualOpen(false)}
                onCreated={() => carregar()}
            />
            <EditarReclamacaoManualModal
                isOpen={editarManualOpen}
                onClose={() => setEditarManualOpen(false)}
                reclamacao={detalhe?.reclamacao}
                onUpdated={() => { if (selecionada) carregarDetalhe(selecionada.id); carregar(); }}
            />
            <ReembolsoMercadoPagoModal
                isOpen={reembolsoMpOpen}
                onClose={() => setReembolsoMpOpen(false)}
                registroId={selecionada?.id}
                recurso="reclamacoes"
                onSuccess={() => { if (selecionada) carregarDetalhe(selecionada.id); carregar(); }}
            />
            <ConfirmPortal />
        </Box>
    );
}

function CardReclamacao({ rec, onAbrir }) {
    const sv = statusVisual(rec);
    const resumo = rec.resumo || {};
    const prod = resumo.produto;
    return (
        <Box bg="white" borderWidth="1px" borderColor="gray.200" borderLeftWidth="5px" borderLeftColor={`${sv.color}.400`}
            borderRadius="lg" p={4} boxShadow="sm" cursor="pointer" _hover={{ boxShadow: 'md', transform: 'translateY(-1px)' }} transition="all .15s"
            onClick={() => onAbrir(rec)}>
            <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
                <ProdutoMini resumo={resumo} size="64px" />
                <VStack align="start" spacing={1.5} minW={0} flex="1">
                    <HStack spacing={2} wrap="wrap">
                        <Tooltip label={sv.label} hasArrow><Tag size="sm" colorScheme={sv.color} variant="solid"><Icon as={sv.icon} mr={1} boxSize={3} />{sv.label}</Tag></Tooltip>
                        <ContaTag conta={rec.conta} origem={rec.origem} />
                        <Tooltip label={rec.stage === 'dispute' ? 'Em mediação com o Mercado Livre' : 'Reclamação aberta'} hasArrow><Tag size="sm" colorScheme={rec.stage === 'dispute' ? 'purple' : 'gray'} variant="subtle">{rec.stage === 'dispute' ? 'Mediação' : 'Reclamação'}</Tag></Tooltip>
                        {rec.afeta_reputacao === 'affected' && <Tooltip label="Esta reclamação afeta sua reputação" hasArrow><Tag size="sm" colorScheme="red" variant="subtle"><Icon as={FaShieldAlt} mr={1} boxSize={3} />Reputação</Tag></Tooltip>}
                    </HStack>
                    <Tooltip label={prod?.nome || rec.title} hasArrow><Text fontWeight="bold" noOfLines={1} color="gray.800">{prod?.nome || rec.title || 'Reclamação'}</Text></Tooltip>
                    <HStack fontSize="xs" color="red.600" spacing={1}>
                        <Icon as={FaExclamationCircle} boxSize={3} flexShrink={0} />
                        <Text noOfLines={1} fontStyle="italic">{rec.reason_detail || rec.reason_name || 'Motivo não informado'}</Text>
                    </HStack>
                    <HStack fontSize="xs" color="gray.600" spacing={3} wrap="wrap">
                        {resumo.cliente_nome && <HStack spacing={1}><Icon as={FaUser} boxSize={3} color="gray.400" /><Text fontWeight="medium">{resumo.cliente_nome}</Text></HStack>}
                        {resumo.valor_total > 0 && <Text fontWeight="bold" color="gray.800">{formatBRL(resumo.valor_total)}</Text>}
                    </HStack>
                    <RefItem produto={prod} />
                    <RefVenda resumo={resumo} rec={rec} />
                    <DataAbertura rec={rec} />
                </VStack>
                <VStack align={{ base: 'start', md: 'end' }} spacing={2} justify="space-between">
                    {rec.status !== 'closed' && <PrazoBadge urgency={rec.urgency_level} dueDate={rec.due_date} />}
                    <Button size="sm" colorScheme="blue" onClick={(e) => { e.stopPropagation(); onAbrir(rec); }}>{rec.status === 'closed' ? 'Ver' : rec.stage === 'dispute' ? 'Responder' : 'Atender'}</Button>
                </VStack>
            </Flex>
        </Box>
    );
}

function KanbanCard({ rec, color, onAbrir }) {
    const resumo = rec.resumo || {};
    const prod = resumo.produto;
    return (
        <Box bg="white" borderRadius="lg" p={3} boxShadow="sm" cursor="pointer" _hover={{ boxShadow: 'lg', transform: 'translateY(-2px)' }}
            transition="all .15s" onClick={() => onAbrir(rec)} borderTopWidth="3px" borderTopColor={`${color}.400`}>
            <VStack align="stretch" spacing={2}>
                <HStack justify="space-between">
                    <ContaTag conta={rec.conta} origem={rec.origem} />
                    <Tooltip label={rec.stage === 'dispute' ? 'Em mediação' : 'Reclamação'} hasArrow><Tag size="sm" colorScheme={rec.stage === 'dispute' ? 'purple' : 'gray'} variant="subtle">{rec.stage === 'dispute' ? 'Mediação' : 'Reclamação'}</Tag></Tooltip>
                </HStack>
                <Divider />
                <HStack spacing={2} align="start">
                    <ProdutoMini resumo={resumo} size="46px" />
                    <VStack align="start" spacing={0.5} flex="1" minW={0}>
                        <Tooltip label={prod?.nome || rec.title} hasArrow><Text fontSize="xs" fontWeight="semibold" noOfLines={2} lineHeight="1.3">{prod?.nome || rec.title || 'Reclamação'}</Text></Tooltip>
                    </VStack>
                </HStack>
                <HStack spacing={1} color="red.600">
                    <Icon as={FaExclamationCircle} boxSize="10px" flexShrink={0} />
                    <Text fontSize="10px" noOfLines={1} fontStyle="italic">{rec.reason_detail || rec.reason_name || 'Motivo não informado'}</Text>
                </HStack>
                <HStack justify="space-between">
                    {resumo.cliente_nome ? (
                        <Tooltip label={resumo.cliente_nome} hasArrow><HStack spacing={1} minW={0}><Icon as={FaUser} boxSize="9px" color="gray.400" /><Text fontSize="10px" color="gray.600" noOfLines={1}>{resumo.cliente_nome}</Text></HStack></Tooltip>
                    ) : <Box />}
                    {resumo.valor_total > 0 && <Text fontSize="13px" fontWeight="bold" color="gray.800" flexShrink={0}>{formatBRL(resumo.valor_total)}</Text>}
                </HStack>
                <Divider />
                <RefItem produto={prod} />
                <RefVenda resumo={resumo} rec={rec} />
                <HStack justify="space-between" align="center">
                    <DataAbertura rec={rec} />
                    {rec.status !== 'closed' && <PrazoBadge urgency={rec.urgency_level} dueDate={rec.due_date} />}
                </HStack>
            </VStack>
        </Box>
    );
}

function matchItem(rec, term) {
    if (!term) return true;
    const t = term.toLowerCase();
    const r = rec.resumo || {};
    const p = r.produto || {};
    const ids = r.ids || {};
    const campos = [
        rec.id_ml, rec.id_order_ml, rec.resource_id, rec.title, rec.reason_detail, rec.reason_name,
        p.nome, p.sku, p.codigo_global, p.codigo_fornecedor, r.cliente_nome,
        ids.id_venda, ids.id_origem, ids.pack_id_ml,
    ];
    return campos.some((f) => f != null && String(f).toLowerCase().includes(t));
}

const COL_BG = { seller: '#FFF3E6', buyer: '#E8F1FE', mediator: '#F3EAFE', closed: '#E6F6EA' };

function KanbanView({ itens, onAbrir }) {
    const [colSearch, setColSearch] = useState({ seller: '', buyer: '', mediator: '', closed: '' });
    const cols = [
        { key: 'seller', label: 'Sua vez', color: 'orange', icon: FaUserTie, tip: 'Você precisa responder ou resolver' },
        { key: 'buyer', label: 'Aguardando comprador', color: 'blue', icon: FaUser, tip: 'Aguardando ação do comprador' },
        { key: 'mediator', label: 'Mercado Livre', color: 'purple', icon: FaStore, tip: 'Em mediação com o Mercado Livre' },
        { key: 'closed', label: 'Finalizadas', color: 'green', icon: FaCheckCircle, tip: 'Reclamações encerradas' },
    ];
    const grupos = { seller: [], buyer: [], mediator: [], closed: [] };
    itens.forEach((i) => {
        if (i.status === 'closed') grupos.closed.push(i);
        else grupos[respKey(i.action_responsible)].push(i);
    });

    return (
        <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }} gap={4} alignItems="start">
            {cols.map((col) => {
                const termo = colSearch[col.key].trim();
                const filtrados = grupos[col.key].filter((r) => matchItem(r, termo));
                return (
                    <VStack key={col.key} align="stretch" bg={COL_BG[col.key]} borderRadius="lg" boxShadow="inner" maxH="82vh" spacing={0}>
                        <Box position="sticky" top={0} zIndex={2} bg={COL_BG[col.key]} borderTopRadius="lg" pt={3} px={3} pb={2}>
                            <HStack justify="space-between" mb={2}>
                                <Tooltip label={col.tip} hasArrow><HStack spacing={2}><Icon as={col.icon} color={`${col.color}.500`} /><Text fontWeight="bold" fontSize="sm" color={`${col.color}.700`}>{col.label}</Text></HStack></Tooltip>
                                <Badge colorScheme={col.color} borderRadius="full" px={2}>{termo ? `${filtrados.length}/${grupos[col.key].length}` : grupos[col.key].length}</Badge>
                            </HStack>
                            <InputGroup size="sm">
                                <InputLeftElement pointerEvents="none"><Icon as={FaSearch} color="gray.400" boxSize={3} /></InputLeftElement>
                                <Input bg="white" borderRadius="md" placeholder="Buscar produto, SKU, cliente, ID..." value={colSearch[col.key]}
                                    onChange={(e) => setColSearch((s) => ({ ...s, [col.key]: e.target.value }))} />
                                {termo && (
                                    <InputRightElement>
                                        <IconButton size="xs" variant="ghost" aria-label="Limpar" icon={<FaTimes />} onClick={() => setColSearch((s) => ({ ...s, [col.key]: '' }))} />
                                    </InputRightElement>
                                )}
                            </InputGroup>
                        </Box>
                        <VStack align="stretch" spacing={2} p={3} pt={2} flex="1" overflowY="auto"
                            sx={{ '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.15)', borderRadius: '4px' } }}>
                            {filtrados.map((rec) => <KanbanCard key={rec.id} rec={rec} color={col.color} onAbrir={onAbrir} />)}
                            {filtrados.length === 0 && <Text fontSize="xs" color="gray.400" textAlign="center" py={4}>{termo ? 'Nada encontrado' : 'Nada aqui'}</Text>}
                        </VStack>
                    </VStack>
                );
            })}
        </Grid>
    );
}

function DetalheReclamacao({ detalhe, onAtualizar }) {
    const toast = useToast();
    const r = detalhe.reclamacao;
    const venda = detalhe.venda;
    const itens = detalhe.itens || [];
    const cliente = venda?.cliente || {};
    const endereco = cliente.enderecos?.[0] || {};
    const sv = statusVisual(r);
    const acoes = r.available_actions || [];
    const compradorMlId = (r.players || []).find((p) => p.role === 'complainant')?.user_id;
    const ehManual = r.origem && r.origem !== 'ml';
    const [movendo, setMovendo] = useState(false);

    const moverManual = async (patch) => {
        setMovendo(true);
        const resp = await atualizarReclamacaoManual(r.id, patch);
        setMovendo(false);
        if (resp?.success) {
            toast({ title: 'Reclamação movida', status: 'success', duration: 1800, position: 'top-right' });
            onAtualizar && onAtualizar();
        } else {
            toast({ title: 'Falha ao mover', description: resp?.error || 'Erro', status: 'error', duration: 4000 });
        }
    };

    const Secao = ({ titulo, icon, children }) => (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={3}><Icon as={icon} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">{titulo}</Text></HStack>
            {children}
        </Box>
    );

    const totalMsgs = (detalhe.mensagens.cliente.length || 0) + (detalhe.mensagens.mediador.length || 0);
    return (
        <Tabs colorScheme="orange" variant="line" size="md" isLazy flex="1" minH={0} display={{ base: 'block', md: 'flex' }} flexDirection="column">
            <TabList flexShrink={0} bg="gray.50" mb={3} overflowX="auto" overflowY="hidden">
                <Tab fontWeight="bold">Informações</Tab>
                {!ehManual && <Tab fontWeight="bold">Conversas{totalMsgs ? ` (${totalMsgs})` : ''}</Tab>}
                <Tab fontWeight="bold">Observações{detalhe.observacoes?.length ? ` (${detalhe.observacoes.length})` : ''}</Tab>
                {!ehManual && <Tab fontWeight="bold">Histórico</Tab>}
            </TabList>
            <TabPanels flex="1" minH={0} overflow={{ base: 'visible', md: 'hidden' }}>
                <TabPanel px={0} h={{ base: 'auto', md: '100%' }} overflowY={{ base: 'visible', md: 'auto' }}>
                    <VStack align="stretch" spacing={4} pb={3}>
            {ehManual && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <HStack mb={3}><Icon as={FaColumns} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Mover no kanban</Text></HStack>
                    <Stack direction={{ base: 'column', sm: 'row' }} spacing={3}>
                        <Box flex="1">
                            <Text fontSize="xs" color="gray.500" mb={1}>Etapa</Text>
                            <Select size="sm" value={r.action_responsible || 'seller'} isDisabled={movendo}
                                onChange={(e) => moverManual({ action_responsible: e.target.value })}>
                                <option value="seller">Sua vez de responder</option>
                                <option value="buyer">Aguardando o comprador</option>
                            </Select>
                        </Box>
                        <Box flex="1">
                            <Text fontSize="xs" color="gray.500" mb={1}>Status</Text>
                            <Select size="sm" value={r.status || 'opened'} isDisabled={movendo}
                                onChange={(e) => moverManual({ status: e.target.value })}>
                                <option value="opened">Aberta</option>
                                <option value="closed">Encerrada (Finalizadas)</option>
                            </Select>
                        </Box>
                    </Stack>
                </Box>
            )}
            {ehManual && (r.dados_adicionais?.itens_reclamados?.length > 0) && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <HStack mb={2}><Icon as={FaBoxOpen} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Itens reclamados ({r.quantity_type === 'total' ? 'total' : 'parcial'})</Text></HStack>
                    <VStack align="stretch" spacing={1}>
                        {r.dados_adicionais.itens_reclamados.map((it) => (
                            <HStack key={it.produto_id} justify="space-between" fontSize="sm">
                                <Text noOfLines={1}>{it.nome}</Text>
                                <Badge colorScheme="orange">{it.quantidade} un</Badge>
                            </HStack>
                        ))}
                    </VStack>
                </Box>
            )}
            <Box bg={`${sv.color}.500`} color="white" borderRadius="lg" p={4}>
                <HStack justify="space-between" wrap="wrap" gap={2}>
                    <HStack><Icon as={sv.icon} boxSize={5} /><Text fontWeight="bold" fontSize="lg">{sv.label}</Text></HStack>
                    {r.status === 'closed'
                        ? <Badge colorScheme="whiteAlpha" bg="whiteAlpha.400" color="white" px={2} py={1} borderRadius="md" fontSize="11px">{r.last_updated_ml ? `Finalizada em ${formatDate(r.last_updated_ml)}` : 'Finalizada'}</Badge>
                        : <PrazoBadge urgency={r.urgency_level} dueDate={r.due_date} />}
                </HStack>
                {r.status !== 'closed' && r.has_incentive && (
                    <HStack mt={2} fontSize="sm" bg="whiteAlpha.300" p={2} borderRadius="md"><Icon as={FaShieldAlt} /><Text>Responda em até 48h para proteger sua reputação.</Text></HStack>
                )}
            </Box>

            <Secao titulo="Dados da reclamação" icon={FaExclamationTriangle}>
                <Text fontWeight="bold" mb={1}>{r.title || 'Reclamação'}</Text>
                <Text fontSize="sm" color="gray.600" mb={1}>{r.problem || r.reason_detail || 'Sem descrição'}</Text>
                {r.description && r.description !== r.problem && <Text fontSize="xs" color="gray.500" mb={3} fontStyle="italic">{r.description}</Text>}
                <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3} mt={2}>
                    <InfoRow label="Tipo" value={r.stage === 'dispute' ? 'Mediação' : 'Reclamação'} />
                    <InfoRow label="Status" value={r.status === 'opened' ? 'Aberta' : 'Encerrada'} />
                    <InfoRow label="Conta" value={contaLabel(r.conta)} />
                    <InfoRow label="Motivo" value={r.reason_detail || r.reason_name} />
                    <InfoRow label="Quantidade reclamada" value={r.quantity_type === 'partial' ? `${r.claimed_quantity ?? ''} unidade(s)`.trim() : 'Total'} />
                    <InfoRow label="Pedido concluído" value={r.fulfilled === true ? 'Sim' : (r.fulfilled === false ? 'Não' : null)} />
                    <InfoRow label="Afeta reputação" value={r.afeta_reputacao === 'affected' ? 'Sim' : 'Não'} />
                </SimpleGrid>
            </Secao>

            <Secao titulo="Datas e prazos" icon={FaClock}>
                <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3}>
                    <InfoRow label="Aberta em" value={r.date_created_ml ? formatDateTime(r.date_created_ml) : null} />
                    <InfoRow label="Prazo para responder" value={r.due_date ? formatDateTime(r.due_date) : 'Sem prazo'} />
                    {r.has_incentive && r.incentive_due_date && <InfoRow label="Proteção reputação (48h)" value={formatDateTime(r.incentive_due_date)} />}
                    <InfoRow label="Última atualização" value={r.last_updated_ml ? formatDateTime(r.last_updated_ml) : null} />
                    {r.status === 'closed' && <InfoRow label="Finalizada em" value={r.last_updated_ml ? formatDateTime(r.last_updated_ml) : null} />}
                    {r.respondido_em && <InfoRow label="Respondido em" value={formatDateTime(r.respondido_em)} />}
                    <InfoRow label="Última sincronização" value={r.last_api_sync_at ? formatDateTime(r.last_api_sync_at) : null} />
                </SimpleGrid>
            </Secao>

            {r.status === 'closed' && (
                <Box bg="green.50" borderRadius="lg" borderWidth="1px" borderColor="green.200" p={4}>
                    <HStack mb={3}><Icon as={FaCheckCircle} color="green.500" /><Text fontWeight="bold" fontSize="sm" color="green.700">Resolução</Text></HStack>
                    {r.resolution ? (
                        <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
                            <InfoRow label="Como foi resolvida" value={labelResolucao(r.resolution.reason)} />
                            <InfoRow label="Beneficiado" value={(r.resolution.benefited || []).map(papelLabel).join(', ') || 'Não informado'} />
                            <InfoRow label="Encerrada por" value={papelLabel(r.resolution.closed_by)} />
                            <InfoRow label="Data da resolução" value={r.resolution.date_created ? formatDateTime(r.resolution.date_created) : null} />
                        </SimpleGrid>
                    ) : (
                        <Text fontSize="sm" color="gray.500">O Mercado Livre não detalhou a resolução desta reclamação.</Text>
                    )}
                </Box>
            )}

            {!venda && (
                <Box bg="orange.50" borderRadius="lg" borderWidth="1px" borderColor="orange.200" p={4}>
                    <HStack align="start" spacing={2}>
                        <Icon as={FaExclamationCircle} color="orange.500" mt={0.5} />
                        <Text fontSize="sm" color="orange.800">
                            Venda não localizada no sistema {r.id_order_ml ? `(pedido #${r.id_order_ml})` : ''}. Pode ser um pedido antigo, anterior à integração, por isso os dados de produto e cliente não estão disponíveis.
                        </Text>
                    </HStack>
                </Box>
            )}

            {venda && (
                <Secao titulo="Venda" icon={FaFileInvoiceDollar}>
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3} mb={3}>
                        <Box>
                            <Text fontSize="10px" color="gray.500" fontWeight="semibold" textTransform="uppercase">Pedido</Text>
                            <HStack spacing={1}>
                                <Text fontSize="sm" color="gray.800" fontWeight="medium">#{venda.id_origem}</Text>
                                <AbrirLink label="Abrir venda" href={`/vendas?busca=${encodeURIComponent(venda.id_origem)}`} />
                            </HStack>
                        </Box>
                        <InfoRow label="Data" value={venda.data_venda ? formatDateTime(venda.data_venda) : (venda.created_at ? formatDateTime(venda.created_at) : null)} />
                        <InfoRow label="Status" value={venda.status} />
                        <InfoRow label="Conta" value={contaLabel(venda.conta)} />
                    </SimpleGrid>
                    <HStack spacing={2} wrap="wrap">
                        <Text fontSize="10px" color="gray.500" fontWeight="semibold" flexShrink={0}>Ref. Venda:</Text>
                        <HStack spacing={2} wrap="wrap" rowGap={1} divider={<Text color="gray.300" fontSize="10px">|</Text>}>
                            <IdChip valor={venda.id} label="ID TAGA" />
                            <IdChip valor={venda.id_origem} label="ID Origem" />
                            <IdChip valor={venda.pack_id_ml} label="Pack ID" />
                        </HStack>
                    </HStack>
                </Secao>
            )}

            <FinanceiroSecao financeiro={detalhe.financeiro} />

            {itens.length > 0 && (
                <Secao titulo="Produtos" icon={FaBoxOpen}>
                    <VStack align="stretch" spacing={3}>
                        {itens.map((it, i) => (
                            <Flex key={i} gap={3} align="center" p={2} borderWidth="1px" borderColor="gray.100" borderRadius="md" bg="gray.50">
                                <Box w="56px" h="56px" flexShrink={0} borderRadius="md" overflow="hidden" bg="white">
                                    <ProdutoImagem produto={it} origem={null} width="100%" height="100%" />
                                </Box>
                                <VStack align="start" spacing={1} flex="1" minW={0}>
                                    <HStack spacing={1} align="start">
                                        <Text fontSize="sm" fontWeight="bold" noOfLines={2}>{it.nome}</Text>
                                        {it.sku && <AbrirLink label="Abrir produto" href={`/produtos?id=${encodeURIComponent(it.sku)}`} />}
                                    </HStack>
                                    <RefItem produto={it} />
                                    <HStack fontSize="xs" color="gray.600" spacing={3}>
                                        <Text>Qtd: <b>{it.quantidade}</b></Text>
                                        <Text fontWeight="bold">{formatBRL(it.valor_unitario)}</Text>
                                    </HStack>
                                </VStack>
                            </Flex>
                        ))}
                    </VStack>
                </Secao>
            )}

            {cliente?.nome && (
                <Secao titulo="Cliente" icon={FaUser}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
                        <Box>
                            <Text fontSize="10px" color="gray.500" fontWeight="semibold" textTransform="uppercase">Nome</Text>
                            <HStack spacing={1}>
                                <Text fontSize="sm" color="gray.800" fontWeight="medium">{cliente.nome}</Text>
                                <AbrirLink label="Abrir cliente" href={`/clientes?search=${encodeURIComponent(cliente.documento || cliente.nome)}`} />
                            </HStack>
                        </Box>
                        <InfoRow label="Documento" value={cliente.documento} />
                        <InfoRow label="Telefone" value={cliente.telefone} />
                        <InfoRow label="Email" value={cliente.email} />
                        {compradorMlId && <InfoRow label="Comprador (ID ML)" value={String(compradorMlId)} />}
                    </SimpleGrid>
                    {endereco?.rua && (
                        <HStack mt={3} fontSize="sm" color="gray.600" align="start">
                            <Icon as={FaMapMarkerAlt} color="gray.400" mt={1} />
                            <Text>{[endereco.rua, endereco.numero, endereco.bairro, endereco.cidade, endereco.estado, endereco.cep].filter(Boolean).join(', ')}</Text>
                        </HStack>
                    )}
                </Secao>
            )}

            <ConferenciaSecao conferencias={detalhe.conferencias || []} />

            <AcoesResolucao reclamacao={r} acoes={acoes} onAtualizar={onAtualizar} />

            <TicketsSecao tickets={detalhe.tickets || []} />
                    </VStack>
                </TabPanel>
                {!ehManual && (
                <TabPanel px={0} h={{ base: 'calc(100dvh - 150px)', md: '100%' }} minH={{ base: '420px', md: 'auto' }} display="flex" flexDirection="column" overflow="hidden">
                    <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={2} flex="1" minH={0} display="flex" flexDirection="column">
                        <Tabs colorScheme="orange" variant="soft-rounded" size="sm" flex="1" minH={0} display="flex" flexDirection="column">
                            <TabList px={2} pt={2} flexShrink={0}>
                                <Tab>Comprador ({detalhe.mensagens.cliente.length})</Tab>
                                <Tab>Mercado Livre ({detalhe.mensagens.mediador.length})</Tab>
                            </TabList>
                            <TabPanels flex="1" minH={0} overflow="hidden">
                                <TabPanel px={2} h="100%" display="flex" flexDirection="column">
                                    <Timeline mensagens={detalhe.mensagens.cliente} reclamacaoId={r.id} />
                                    <CaixaResposta reclamacao={r} canal="complainant" disponivel={temAcao(acoes, 'send_message_to_complainant')} bloqueadoMediacao={r.stage === 'dispute'} onEnviado={onAtualizar} />
                                </TabPanel>
                                <TabPanel px={2} h="100%" display="flex" flexDirection="column">
                                    <Timeline mensagens={detalhe.mensagens.mediador} reclamacaoId={r.id} />
                                    <CaixaResposta reclamacao={r} canal="mediator" disponivel={temAcao(acoes, 'send_message_to_mediator')} onEnviado={onAtualizar} />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Box>
                </TabPanel>
                )}
                <TabPanel px={0} h={{ base: 'auto', md: '100%' }} overflowY={{ base: 'visible', md: 'auto' }}>
                    <ObservacoesVenda observacoes={detalhe.observacoes || []} vendaId={venda?.id} onAdicionado={onAtualizar} />
                </TabPanel>
                {!ehManual && (
                <TabPanel px={0} h={{ base: 'auto', md: '100%' }} overflowY={{ base: 'visible', md: 'auto' }}>
                    <VStack align="stretch" spacing={4}>
                        <HistoricoCaso statusHistory={r.status_history} actionsHistory={r.actions_history} />
                        <TimelineEnvioSecao titulo="Entrega do pedido" envio={detalhe.entrega_pedido} />
                        <TimelineEnvioSecao titulo="Envio da devolução" envio={detalhe.devolucao_envio} />
                    </VStack>
                </TabPanel>
                )}
            </TabPanels>
        </Tabs>
    );
}

const STATUS_CONF = {
    1: { label: 'Verificado com Sucesso', color: 'green' },
    2: { label: 'Verificado com Problema', color: 'red' },
    3: { label: 'Verificado - Embalado', color: 'green' },
    4: { label: 'Verificado - Enviado', color: 'green' },
    5: { label: 'Verificado - Liberado com Ressalva', color: 'green' },
};
const CONF_PROBLEMAS = [
    ['foto_check', 'Foto'], ['nome_check', 'Nome'], ['codigo_check', 'Código'],
    ['marca_check', 'Marca'], ['avaria_check', 'Avaria'],
];

function ConferenciaSecao({ conferencias }) {
    if (!conferencias || conferencias.length === 0) return null;
    return (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={3}><Icon as={FaCheckCircle} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Conferência do produto (antes do envio)</Text></HStack>
            <VStack align="stretch" spacing={3}>
                {conferencias.map((c) => {
                    const st = STATUS_CONF[c.status_conferencia] || { label: 'Não conferido', color: 'gray' };
                    const problemas = CONF_PROBLEMAS.filter(([k]) => c[k]);
                    return (
                        <Box key={c.id} bg="gray.50" borderRadius="md" borderWidth="1px" borderColor="gray.200" p={4}>
                            <HStack justify="space-between" mb={3} wrap="wrap" gap={2}>
                                <Text fontSize="sm" fontWeight="semibold" noOfLines={1}>{c.produto?.nome || 'Produto'}</Text>
                                <Tag size="md" colorScheme={st.color} variant="solid" borderRadius="md">
                                    <Icon as={st.color === 'red' ? FaExclamationTriangle : FaCheckCircle} mr={1} boxSize={3} />{st.label}
                                </Tag>
                            </HStack>
                            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} mb={problemas.length || (c.outro_fornecedor_check) || c.observacao ? 3 : 0}>
                                <InfoRow label="Data da conferência" value={c.updated_at ? formatDateTime(c.updated_at) : null} />
                                <InfoRow label="Unidades" value={`${c.unidades_check ?? 'N/A'} conferida(s) de ${c.quantidade_esperada ?? 'N/A'} esperada(s)`} />
                            </SimpleGrid>
                            {Boolean(c.outro_fornecedor_check) && (
                                <HStack mb={problemas.length || c.observacao ? 3 : 0} fontSize="sm" color="blue.700" bg="blue.50" p={2} borderRadius="md" wrap="wrap">
                                    <Icon as={FaBoxOpen} color="blue.500" />
                                    <Text>Produto atendido por <b>fornecedor alternativo</b>.</Text>
                                    {c.outro_fornecedor_nome && <Tag size="sm" colorScheme="purple">{c.outro_fornecedor_nome}</Tag>}
                                </HStack>
                            )}
                            {c.status_conferencia === 2 && problemas.length > 0 && (
                                <Box mb={c.observacao ? 3 : 0}>
                                    <Text fontSize="11px" color="red.500" fontWeight="semibold" textTransform="uppercase" mb={1}>Problemas apontados</Text>
                                    <Wrap spacing={2}>
                                        {problemas.map(([k, label]) => (
                                            <WrapItem key={k}><Tag size="sm" colorScheme="red" variant="subtle"><Icon as={FaExclamationTriangle} mr={1} boxSize={2.5} />{label}</Tag></WrapItem>
                                        ))}
                                    </Wrap>
                                </Box>
                            )}
                            {c.observacao && (
                                <Box>
                                    <Text fontSize="11px" color="gray.500" fontWeight="semibold" textTransform="uppercase" mb={1}>Observação</Text>
                                    <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap" bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="md" p={2}>{c.observacao}</Text>
                                </Box>
                            )}
                        </Box>
                    );
                })}
            </VStack>
        </Box>
    );
}

function HistoricoCaso({ statusHistory, actionsHistory }) {
    const eventos = [];
    (statusHistory || []).forEach((s) => eventos.push({
        date: s.date, tipo: 'status',
        label: `${s.stage === 'dispute' ? 'Mediação' : 'Reclamação'} ${s.status === 'opened' ? 'aberta' : 'encerrada'}`,
        por: s.change_by,
    }));
    (actionsHistory || []).forEach((a) => eventos.push({
        date: a.date_created, tipo: 'acao', label: labelAcao(a.action_name), por: a.player_role,
    }));
    eventos.sort((x, y) => dayjs(x.date).valueOf() - dayjs(y.date).valueOf());
    const vistos = new Set();
    const unicos = eventos.filter((e) => {
        const k = `${e.label}|${e.date}|${e.por}`;
        if (vistos.has(k)) return false;
        vistos.add(k);
        return true;
    });

    if (unicos.length === 0) {
        return (
            <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={6} textAlign="center">
                <Text color="gray.400" fontSize="sm">Sem histórico registrado para este caso.</Text>
            </Box>
        );
    }
    return (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={4}><Icon as={FaClock} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Histórico do caso</Text></HStack>
            <VStack align="stretch" spacing={0}>
                {unicos.map((e, i) => (
                    <HStack key={i} align="start" spacing={3}>
                        <VStack spacing={0} align="center">
                            <Box boxSize="12px" borderRadius="full" bg={e.tipo === 'status' ? 'purple.400' : 'green.400'} mt={1} flexShrink={0} />
                            {i < unicos.length - 1 && <Box w="2px" h="32px" bg="gray.200" />}
                        </VStack>
                        <Box pb={3} flex="1" minW={0}>
                            <HStack justify="space-between" wrap="wrap" gap={1}>
                                <Text fontSize="sm" fontWeight="medium" color="gray.800">{e.label}</Text>
                                <Text fontSize="11px" color="gray.400">{e.date ? formatDateTime(e.date) : ''}</Text>
                            </HStack>
                            {e.por && <Text fontSize="xs" color="gray.500">por {papelLabel(e.por)}</Text>}
                        </Box>
                    </HStack>
                ))}
            </VStack>
        </Box>
    );
}

const REFUND_AT_LABEL = { shipped: 'liberado ao enviar a devolução', delivered: 'liberado ao receber a devolução' };

function TimelineEnvioSecao({ titulo, envio }) {
    if (!envio) return null;
    const estagios = envio.estagios || [];
    const atual = envio.atual ?? 0;
    return (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={3}><Icon as={FaBoxOpen} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">{titulo}</Text></HStack>
            <VStack align="stretch" spacing={0} mb={3}>
                {estagios.map((e, i) => {
                    const done = i < atual;
                    const current = i === atual;
                    const ativo = done || current;
                    return (
                        <HStack key={e.key} align="start" spacing={3}>
                            <VStack spacing={0} align="center">
                                <Box boxSize="14px" borderRadius="full" bg={ativo ? 'green.400' : 'gray.200'} borderWidth={current ? '3px' : '0'} borderColor="green.200" />
                                {i < estagios.length - 1 && <Box w="2px" h="26px" bg={done ? 'green.300' : 'gray.200'} />}
                            </VStack>
                            <Box pb={3}>
                                <Text fontSize="sm" fontWeight={current ? 'bold' : 'medium'} color={ativo ? 'green.700' : 'gray.500'}>{e.label}</Text>
                                {e.data && <Text fontSize="11px" color="gray.500">{formatDateTime(e.data)}</Text>}
                            </Box>
                        </HStack>
                    );
                })}
            </VStack>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
                {envio.tracking_number && (
                    <Box>
                        <Text fontSize="10px" color="gray.500" fontWeight="semibold" textTransform="uppercase">Rastreio</Text>
                        {envio.link_rastreio
                            ? <Link href={envio.link_rastreio} isExternal fontSize="sm" color="blue.500">{envio.tracking_number}</Link>
                            : <IdChip valor={envio.tracking_number} label="Rastreio" />}
                    </Box>
                )}
                {envio.transportadora && <InfoRow label="Transportadora" value={envio.transportadora} />}
                {envio.refund_at && <InfoRow label="Reembolso" value={REFUND_AT_LABEL[envio.refund_at] || envio.refund_at} />}
            </SimpleGrid>
            {envio.destino && (
                <HStack mt={2} fontSize="xs" color="gray.500" align="start">
                    <Icon as={FaMapMarkerAlt} boxSize={3} mt={0.5} flexShrink={0} />
                    <Text>Destino: {envio.destino}</Text>
                </HStack>
            )}
        </Box>
    );
}

function FinanceiroSecao({ financeiro }) {
    if (!financeiro || (financeiro.total == null && financeiro.tarifa_venda == null)) return null;
    return (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={3}><Icon as={FaFileInvoiceDollar} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Financeiro do pedido</Text></HStack>
            <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
                <InfoRow label="Valor total" value={financeiro.total != null ? formatBRL(financeiro.total) : null} />
                <InfoRow label="Tarifa de venda (ML)" value={financeiro.tarifa_venda != null ? formatBRL(financeiro.tarifa_venda) : null} />
                <InfoRow label="Frete" value={financeiro.frete != null ? formatBRL(financeiro.frete) : null} />
                <InfoRow label="Líquido estimado" value={financeiro.liquido != null ? formatBRL(financeiro.liquido) : null} />
            </SimpleGrid>
        </Box>
    );
}

const TICKET_STATUS = {
    aberto: { label: 'Aberto', color: 'blue' },
    em_andamento: { label: 'Em andamento', color: 'orange' },
    pendente: { label: 'Pendente', color: 'yellow' },
    fechado: { label: 'Concluído', color: 'green' },
};
const TICKET_PRIORIDADE = { alta: 'red', media: 'orange', baixa: 'gray' };

function TicketsSecao({ tickets }) {
    if (!tickets || tickets.length === 0) return null;
    return (
        <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
            <HStack mb={3}><Icon as={FaTicketAlt} color="orange.500" /><Text fontWeight="bold" fontSize="sm" color="gray.700">Ticket interno</Text></HStack>
            <VStack align="stretch" spacing={2}>
                {tickets.map((t) => {
                    const st = TICKET_STATUS[t.status] || { label: t.status, color: 'gray' };
                    return (
                        <Box key={t.id} bg="gray.50" borderRadius="md" borderWidth="1px" borderColor="gray.200" p={3}>
                            <HStack justify="space-between" mb={1} wrap="wrap" gap={2}>
                                <HStack spacing={2}>
                                    <Text fontWeight="bold" fontSize="sm" color="gray.700">#{t.id}</Text>
                                    <Tag size="sm" colorScheme={st.color} variant="solid">{st.label}</Tag>
                                    {t.prioridade && <Tag size="sm" colorScheme={TICKET_PRIORIDADE[t.prioridade] || 'gray'} variant="subtle">{t.prioridade}</Tag>}
                                    <AbrirLink label="Abrir ticket" href={`/tickets/${t.id}`} />
                                </HStack>
                                <Text fontSize="11px" color="gray.400">{t.created_at ? formatDateTime(t.created_at) : ''}</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.800" noOfLines={2}>{t.titulo}</Text>
                            <HStack fontSize="xs" color="gray.500" mt={1} spacing={3} wrap="wrap">
                                {t.autor?.name && <Text>Autor: {t.autor.name}</Text>}
                                {t.comentarios_count > 0 && <Text>{t.comentarios_count} comentário(s)</Text>}
                                {t.data_prazo && <Text>Prazo: {formatDate(t.data_prazo)}</Text>}
                            </HStack>
                        </Box>
                    );
                })}
            </VStack>
        </Box>
    );
}

function ObservacoesVenda({ observacoes, vendaId, onAdicionado }) {
    const toast = useToast();
    const [texto, setTexto] = useState('');
    const [arquivos, setArquivos] = useState([]);
    const [enviando, setEnviando] = useState(false);
    const fileRef = useRef();

    const enviar = async () => {
        if (!texto.trim() && arquivos.length === 0) return;
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const fd = new FormData();
        fd.append('id', vendaId);
        fd.append('id_user', user.id);
        fd.append('obs', texto);
        arquivos.forEach((f) => fd.append('files[]', f));
        setEnviando(true);
        const res = await criarObsVenda(fd);
        setEnviando(false);
        if (res !== false) {
            setTexto('');
            setArquivos([]);
            if (fileRef.current) fileRef.current.value = '';
            toast({ title: 'Observação adicionada', status: 'success', duration: 2000, position: 'top-right' });
            onAdicionado && onAdicionado();
        } else {
            toast({ title: 'Falha ao adicionar observação', status: 'error', duration: 4000, position: 'top-right' });
        }
    };

    return (
        <VStack align="stretch" spacing={3}>
            {(!observacoes || observacoes.length === 0) && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={6} textAlign="center">
                    <Text color="gray.400" fontSize="sm">Nenhuma observação registrada nesta venda.</Text>
                </Box>
            )}
            {observacoes.map((o) => (
                <Box key={o.id} bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <HStack justify="space-between" mb={2} wrap="wrap">
                        <HStack spacing={2}>
                            <Avatar size="xs" name={o.usuario?.name} src={imgUsuario(o.usuario?.id)} />
                            <Text fontSize="sm" fontWeight="bold" color="gray.700">{o.usuario?.name || 'Sistema'}</Text>
                            {o.origem && <Tag size="sm" colorScheme="gray" variant="subtle">{o.origem}</Tag>}
                        </HStack>
                        <Text fontSize="11px" color="gray.400">{o.created_at ? formatDateTime(o.created_at) : ''}</Text>
                    </HStack>
                    <Text fontSize="sm" whiteSpace="pre-wrap" color="gray.800">{o.observacao}</Text>
                    {(o.arquivos || []).length > 0 && (
                        <Wrap mt={3} spacing={2}>
                            {o.arquivos.map((a) => {
                                const url = baseUrlApi.replace('api', '') + 'storage/' + a.file_path;
                                const ehImg = /\.(jpe?g|png|gif|webp)$/i.test(a.file_path || '');
                                return (
                                    <WrapItem key={a.id}>
                                        {ehImg
                                            ? <Image src={url} alt={a.file_name || 'anexo'} boxSize="80px" objectFit="cover" borderRadius="md" borderWidth="1px" borderColor="gray.200" cursor="pointer" onClick={() => window.open(url, '_blank')} />
                                            : <Link href={url} isExternal fontSize="11px" color="blue.500" display="inline-flex" alignItems="center"><Icon as={FaPaperclip} mr={1} boxSize={2.5} />{a.file_name || 'arquivo'}</Link>}
                                    </WrapItem>
                                );
                            })}
                        </Wrap>
                    )}
                </Box>
            ))}
            {vendaId && (
                <Box bg="white" borderRadius="lg" borderWidth="1px" borderColor="gray.200" p={4}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.700" mb={2}>Adicionar observação</Text>
                    <Textarea value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Escreva uma observação para esta venda..." size="sm" bg="white" rows={3} />
                    <Flex justify="space-between" align="center" mt={2} wrap="wrap" gap={2}>
                        <Input ref={fileRef} type="file" multiple size="sm" variant="unstyled" fontSize="xs" maxW="240px" onChange={(e) => setArquivos(Array.from(e.target.files))} />
                        <Button size="sm" colorScheme="orange" leftIcon={<FaPaperPlane />} isLoading={enviando} isDisabled={!texto.trim() && arquivos.length === 0} onClick={enviar}>Adicionar</Button>
                    </Flex>
                </Box>
            )}
        </VStack>
    );
}

function AnexoImagem({ reclamacaoId, anexo }) {
    const [url, setUrl] = useState(null);
    const [erro, setErro] = useState(false);
    const ehImagem = (anexo.type || '').startsWith('image/');

    useEffect(() => {
        let ativo = true;
        let obj;
        getAnexoReclamacao(reclamacaoId, anexo.filename).then((blob) => {
            if (!ativo) return;
            if (!blob) { setErro(true); return; }
            obj = URL.createObjectURL(blob);
            setUrl(obj);
        });
        return () => { ativo = false; if (obj) URL.revokeObjectURL(obj); };
    }, [reclamacaoId, anexo.filename]);

    if (erro) return <Text fontSize="11px" color="gray.400">{anexo.original_filename || 'anexo'} (indisponível)</Text>;
    if (!url) return <Flex w="80px" h="80px" align="center" justify="center" bg="gray.100" borderRadius="md"><Spinner size="sm" color="gray.400" /></Flex>;
    if (ehImagem) {
        return (
            <Tooltip label={`${anexo.original_filename || 'imagem'} · clique para ampliar`} hasArrow>
                <Image src={url} alt={anexo.original_filename || 'anexo'} boxSize="80px" objectFit="cover" borderRadius="md"
                    cursor="pointer" borderWidth="1px" borderColor="gray.200" onClick={() => window.open(url, '_blank')} />
            </Tooltip>
        );
    }
    return (
        <Link href={url} download={anexo.original_filename} fontSize="11px" color="blue.500" display="inline-flex" alignItems="center">
            <Icon as={FaPaperclip} mr={1} boxSize={2.5} />{anexo.original_filename || 'arquivo'}
        </Link>
    );
}

function Timeline({ mensagens, reclamacaoId }) {
    if (!mensagens || mensagens.length === 0) {
        return <Flex flex="1" minH={0} align="center" justify="center"><Text color="gray.400" fontSize="sm" py={6} textAlign="center">Nenhuma mensagem neste canal.</Text></Flex>;
    }
    return (
        <VStack align="stretch" spacing={3} py={2} flex="1" minH={0} overflowY="auto">
            {mensagens.map((m) => {
                const meu = m.sender_role === 'respondent';
                return (
                    <Flex key={m.id} justify={meu ? 'flex-end' : 'flex-start'}>
                        <Box bg={meu ? 'orange.50' : 'gray.100'} borderRadius="lg" px={3} py={2} maxW="80%" borderWidth="1px" borderColor={meu ? 'orange.100' : 'gray.200'}>
                            <Text fontSize="10px" color="gray.500" mb={1}>
                                {m.sender_role === 'respondent' ? 'Você' : m.sender_role === 'mediator' ? 'Mercado Livre' : 'Comprador'}
                                {' · '}{m.message_date ? dayjs(m.message_date).format('DD/MM HH:mm') : ''}
                            </Text>
                            {htmlParaTexto(m.message) && <Text fontSize="sm" whiteSpace="pre-wrap" color="gray.800">{htmlParaTexto(m.message)}</Text>}
                            {(m.attachments || []).length > 0 && (
                                <Wrap mt={2} spacing={2}>
                                    {m.attachments.map((a, i) => <WrapItem key={i}><AnexoImagem reclamacaoId={reclamacaoId} anexo={a} /></WrapItem>)}
                                </Wrap>
                            )}
                        </Box>
                    </Flex>
                );
            })}
        </VStack>
    );
}

const EXT_ANEXO_PERMITIDAS = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'pdf', 'txt', 'doc', 'xls', 'xml'];

function CaixaResposta({ reclamacao, canal, disponivel, bloqueadoMediacao, onEnviado }) {
    const toast = useToast();
    const [texto, setTexto] = useState('');
    const [arquivo, setArquivo] = useState(null);
    const [previewArquivo, setPreviewArquivo] = useState(null);
    const [enviando, setEnviando] = useState(false);
    const fileRef = useRef(null);
    const confirmar = useDisclosure();

    if (bloqueadoMediacao && canal === 'complainant') {
        return <Alert status="info" borderRadius="md" mt={3} fontSize="sm"><AlertIcon />Conversa com o comprador desabilitada: há uma mediação aberta. Fale pela aba "Mercado Livre".</Alert>;
    }
    if (!disponivel) return <Text fontSize="sm" color="gray.400" mt={3} textAlign="center">Não é possível enviar mensagem neste canal agora.</Text>;

    const handleArquivo = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        if (f.size > 25 * 1024 * 1024) {
            toast({ title: 'Arquivo muito grande', description: 'O tamanho máximo permitido é 25 MB.', status: 'warning', duration: 4000, position: 'top-right' });
            if (fileRef.current) fileRef.current.value = '';
            return;
        }
        const ext = (f.name.split('.').pop() || '').toLowerCase();
        if (!EXT_ANEXO_PERMITIDAS.includes(ext)) {
            toast({ title: 'Tipo de arquivo não permitido', description: `Use: ${EXT_ANEXO_PERMITIDAS.join(', ')}.`, status: 'warning', duration: 4000, position: 'top-right' });
            if (fileRef.current) fileRef.current.value = '';
            return;
        }
        setArquivo(f);
        if (f.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (ev) => setPreviewArquivo(ev.target.result);
            reader.readAsDataURL(f);
        } else {
            setPreviewArquivo(null);
        }
    };

    const removerArquivo = () => {
        setArquivo(null);
        setPreviewArquivo(null);
        if (fileRef.current) fileRef.current.value = '';
    };

    const abrirConfirmacao = () => {
        if (!texto.trim() && !arquivo) return;
        confirmar.onOpen();
    };

    const enviar = async () => {
        if (!texto.trim() && !arquivo) return;
        setEnviando(true);

        let attachments = [];
        if (arquivo) {
            const form = new FormData();
            form.append('file', arquivo);
            const up = await uploadAnexoReclamacao(reclamacao.id, form);
            if (!up?.sucesso || !up?.file_name) {
                setEnviando(false);
                const motivo = up?.msg
                    || (typeof up?.resposta === 'string' ? up.resposta : up?.resposta?.message)
                    || up?.erro
                    || 'Não foi possível enviar o anexo ao Mercado Livre.';
                toast({ title: 'Falha ao anexar arquivo', description: motivo, status: 'error', duration: 5000, position: 'top-right' });
                return;
            }
            attachments = [up.file_name];
        }

        const res = await responderMensagemReclamacao(reclamacao.id, { message: texto.slice(0, 350), receiver_role: canal, attachments });
        setEnviando(false);
        confirmar.onClose();
        if (res?.sucesso) {
            setTexto('');
            removerArquivo();
            toast({ title: 'Mensagem enviada', status: 'success', duration: 2000, position: 'top-right' });
            onEnviado && onEnviado();
        } else {
            toast({ title: 'Não foi possível enviar', description: res?.erro || '', status: 'error', duration: 4000, position: 'top-right' });
        }
    };

    return (
        <Box mt={3} flexShrink={0}>
            <Textarea value={texto} onChange={(e) => setTexto(e.target.value.slice(0, 350))} maxLength={350} bg="white"
                placeholder={canal === 'mediator' ? 'Escreva ao Mercado Livre...' : 'Escreva ao comprador...'} rows={3} size="sm" />

            {arquivo && (
                <Flex mt={2} align="center" gap={2} bg="gray.50" borderWidth="1px" borderColor="gray.200" borderRadius="md" p={2}>
                    {previewArquivo
                        ? <Image src={previewArquivo} alt={arquivo.name} boxSize="44px" objectFit="cover" borderRadius="md" flexShrink={0} />
                        : <Flex boxSize="44px" align="center" justify="center" bg="gray.100" borderRadius="md" flexShrink={0}><Icon as={FaPaperclip} color="gray.500" /></Flex>}
                    <Text fontSize="xs" color="gray.700" flex="1" minW={0} noOfLines={1}>{arquivo.name}</Text>
                    <IconButton aria-label="Remover anexo" icon={<FaTimes />} size="xs" variant="ghost" colorScheme="red" onClick={removerArquivo} />
                </Flex>
            )}

            <Flex justify="space-between" align="center" mt={2} gap={2}>
                <HStack spacing={2}>
                    <Input ref={fileRef} type="file" accept=".jpg,.jpeg,.png,.heic,.heif,.pdf,.txt,.doc,.xls,.xml" display="none" onChange={handleArquivo} />
                    <Tooltip label="Anexar arquivo" hasArrow>
                        <IconButton aria-label="Anexar arquivo" icon={<FaPaperclip />} size="sm" variant="outline" colorScheme="orange" onClick={() => fileRef.current?.click()} />
                    </Tooltip>
                    <Text fontSize="xs" color={texto.length >= 350 ? 'red.500' : 'gray.400'}>{texto.length}/350</Text>
                </HStack>
                <Button size="sm" colorScheme="orange" leftIcon={<FaPaperPlane />} isDisabled={!texto.trim() && !arquivo} onClick={abrirConfirmacao}>Enviar</Button>
            </Flex>

            <Modal isOpen={confirmar.isOpen} onClose={confirmar.onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Enviar mensagem {canal === 'mediator' ? 'ao Mercado Livre' : 'ao comprador'}?</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="sm" color="gray.600" mb={2}>A mensagem será enviada {canal === 'mediator' ? 'ao mediador do Mercado Livre' : 'ao comprador'} e não pode ser desfeita.</Text>
                        {texto.trim() && (
                            <Box bg="gray.50" borderWidth="1px" borderColor="gray.200" borderRadius="md" p={3} mb={arquivo ? 2 : 0}>
                                <Text fontSize="sm" whiteSpace="pre-wrap">{texto}</Text>
                            </Box>
                        )}
                        {arquivo && (
                            <Flex align="center" gap={2} bg="gray.50" borderWidth="1px" borderColor="gray.200" borderRadius="md" p={2}>
                                {previewArquivo
                                    ? <Image src={previewArquivo} alt={arquivo.name} boxSize="48px" objectFit="cover" borderRadius="md" flexShrink={0} />
                                    : <Flex boxSize="48px" align="center" justify="center" bg="gray.100" borderRadius="md" flexShrink={0}><Icon as={FaPaperclip} color="gray.500" /></Flex>}
                                <VStack align="start" spacing={0} flex="1" minW={0}>
                                    <Text fontSize="xs" fontWeight="medium" color="gray.700" noOfLines={1}>{arquivo.name}</Text>
                                    <Text fontSize="11px" color="gray.500">Anexo</Text>
                                </VStack>
                            </Flex>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={confirmar.onClose}>Cancelar</Button>
                        <Button colorScheme="orange" leftIcon={<FaPaperPlane />} isLoading={enviando} onClick={enviar}>Confirmar e enviar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
}

const ACOES_RESOLUCAO = {
    refund: { rotulo: 'Reembolsar o dinheiro', cor: 'red', dupla: true, titulo: 'Reembolsar o valor total?', texto: 'O comprador receberá o reembolso integral e a reclamação será encerrada. Esta ação é irreversível e processada pelo Mercado Pago.' },
    allow_return: { rotulo: 'Oferecer devolução', cor: 'blue', dupla: false, titulo: 'Oferecer devolução do produto?', texto: 'O Mercado Livre gerará uma etiqueta para o comprador devolver o produto. O reembolso ocorre quando a devolução for enviada ou entregue.' },
    open_dispute: { rotulo: 'Abrir mediação', cor: 'purple', dupla: false, titulo: 'Abrir mediação com o Mercado Livre?', texto: 'Um mediador do Mercado Livre passará a intervir no caso. A conversa direta com o comprador será desabilitada.' },
};

function AcoesResolucao({ reclamacao, acoes, onAtualizar }) {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const parcial = useDisclosure();
    const [acaoAtual, setAcaoAtual] = useState(null);
    const [processando, setProcessando] = useState(false);

    const disponiveis = Object.keys(ACOES_RESOLUCAO).filter((a) => temAcao(acoes, a));
    const temParcial = temAcao(acoes, 'allow_partial_refund');
    const confirmar = (chave) => { setAcaoAtual(chave); onOpen(); };

    const executar = async () => {
        setProcessando(true);
        let res;
        if (acaoAtual === 'refund') res = await reembolsoTotalReclamacao(reclamacao.id);
        else if (acaoAtual === 'allow_return') res = await oferecerDevolucaoReclamacao(reclamacao.id);
        else if (acaoAtual === 'open_dispute') res = await abrirDisputaReclamacao(reclamacao.id);
        setProcessando(false);
        onClose();
        if (res?.sucesso) { toast({ title: 'Ação concluída', status: 'success', duration: 2500, position: 'top-right' }); onAtualizar && onAtualizar(); }
        else toast({ title: 'Não foi possível concluir', description: res?.erro || '', status: 'error', duration: 5000, position: 'top-right' });
    };

    if (disponiveis.length === 0 && !temParcial) return null;
    const cfg = acaoAtual ? ACOES_RESOLUCAO[acaoAtual] : null;

    return (
        <Box bg="orange.50" borderRadius="lg" borderWidth="1px" borderColor="orange.200" p={4}>
            <Text fontSize="sm" color="orange.700" fontWeight="bold" mb={2} textTransform="uppercase">Resolver</Text>
            <Wrap spacing={2}>
                {disponiveis.map((a) => (<WrapItem key={a}><Button size="sm" colorScheme={ACOES_RESOLUCAO[a].cor} onClick={() => confirmar(a)}>{ACOES_RESOLUCAO[a].rotulo}</Button></WrapItem>))}
                {temParcial && <WrapItem><Button size="sm" colorScheme="orange" variant="outline" onClick={parcial.onOpen}>Reembolso parcial</Button></WrapItem>}
            </Wrap>

            <Modal isOpen={isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{cfg?.titulo}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="sm" color="gray.700">{cfg?.texto}</Text>
                        {cfg?.dupla && <Alert status="warning" mt={3} borderRadius="md" fontSize="sm"><AlertIcon />Ação irreversível. Confirme com atenção.</Alert>}
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={onClose}>Cancelar</Button>
                        <Button colorScheme={cfg?.cor || 'blue'} isLoading={processando} onClick={executar}>Confirmar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <ModalReembolsoParcial reclamacao={reclamacao} disclosure={parcial} onAtualizar={onAtualizar} />
        </Box>
    );
}

function ModalReembolsoParcial({ reclamacao, disclosure, onAtualizar }) {
    const toast = useToast();
    const [ofertas, setOfertas] = useState(null);
    const [percentual, setPercentual] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [processando, setProcessando] = useState(false);

    useEffect(() => {
        if (disclosure.isOpen) {
            setCarregando(true);
            ofertasParciaisReclamacao(reclamacao.id).then((d) => { setOfertas(d?.ofertas?.available_offers || []); setCarregando(false); });
        }
    }, [disclosure.isOpen, reclamacao.id]);

    const confirmar = async () => {
        if (!percentual) return;
        setProcessando(true);
        const res = await reembolsoParcialReclamacao(reclamacao.id, { percentage: Number(percentual) });
        setProcessando(false);
        disclosure.onClose();
        if (res?.sucesso) { toast({ title: 'Reembolso parcial oferecido', status: 'success', duration: 2500, position: 'top-right' }); onAtualizar && onAtualizar(); }
        else toast({ title: 'Não foi possível oferecer', description: res?.erro || '', status: 'error', duration: 5000, position: 'top-right' });
    };

    return (
        <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Oferecer reembolso parcial</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="sm" color="gray.600" mb={3}>O comprador receberá uma oferta de reembolso parcial. Se aceitar, a reclamação é encerrada; se recusar, pode abrir disputa.</Text>
                    {carregando ? <Spinner /> : (
                        <RadioGroup value={percentual} onChange={setPercentual}>
                            <VStack align="stretch" spacing={2}>
                                {(ofertas || []).map((o) => (<Radio key={o.percentage} value={String(o.percentage)}>{o.percentage}% · {formatBRL(o.amount)}</Radio>))}
                                {(!ofertas || ofertas.length === 0) && <Text fontSize="sm" color="gray.400">Sem ofertas disponíveis para esta reclamação.</Text>}
                            </VStack>
                        </RadioGroup>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={disclosure.onClose}>Cancelar</Button>
                    <Button colorScheme="orange" isLoading={processando} isDisabled={!percentual} onClick={confirmar}>Oferecer{percentual && ` ${percentual}%`}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
